export const imageResizer = (image, width, height) => {
  if (!image) {
    return null
  }

  const splittedImage = image.split("/")
  splittedImage.splice(splittedImage.length - 1, 0, `${width}x${height}`)
  return splittedImage.join("/")
}
